import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from './confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  constructor(private readonly dialog: MatDialog) {}

  /**
   * Opens the shared confirmation dialog. When `cancel$` emits (a session change or the caller's
   * destruction), the dialog is actually closed and resolves to `false`, so a stale account's modal
   * is never left open awaiting an answer that must not be acted on. The service keeps ownership of
   * the dialog ref; callers only supply the cancellation trigger.
   */
  confirm(data: ConfirmationDialogData, cancel$?: Observable<unknown>): Observable<boolean> {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      data,
      width: '420px',
      maxWidth: 'calc(100vw - 32px)',
      restoreFocus: true,
    });
    cancel$?.pipe(take(1), takeUntil(ref.afterClosed())).subscribe(() => ref.close(false));
    return ref.afterClosed().pipe(map(confirmed => confirmed === true));
  }
}
